import api from '../../../../../../../api'

export default function format_expanded_value(value, attr = null)
{
    var _value = value.toString()

    if(attr)
    {
        if(_value == "true")
            _value = true
        else if(_value == "false")
            _value = false

        _value = api.format_attr_value(attr, _value)
    }
    else
    {
        if(_value == "true")
            return "Да"
        else if(_value == "false")
            return "Нет"
    }

    return _value
}